import { RDShipmentDistance } from '@cibo/core'
import { ITraitFeatureById } from '../types'
import { findInitialValuesDetail } from '../utils'
import { ShipmentDistanceCell } from './ShipmentDistanceCell'
import { ShipmentDistanceEditor } from './ShipmentDistanceEditor'

const TRAIT_ID = 'shipmentDistance'

export const ShipmentDistance: ITraitFeatureById<RDShipmentDistance> = {
  traitId: TRAIT_ID,
  resultsOnly: true,
  cellDisplay: ShipmentDistanceCell,
  editor: ShipmentDistanceEditor,
  initialValues: props => {
    const detail = findInitialValuesDetail(TRAIT_ID)(props)
    return detail ? detail.result : ''
  },
  ns: '@cibo/landmanager/ShipmentDistance',

  detailFromEditorValues: (values: { input: number }) => ({
    traitId: TRAIT_ID,
    result: values.input,
  }),

  validJsonSchema: ({ t }) => ({
    type: 'number',
    minimum: 0,
    errorMessage: {
      minimum: t('minDistanceError'),
    },
  }),

  warningJsonSchema: ({ t }) => ({
    type: 'number',
    minimum: 50,
    errorMessage: {
      minimum: t('minDistanceWarning'),
    },
  }),
}
